import { Dispatch } from 'redux';
import UserGeodataController from '../controllers/UserGeodataController';
import { StoreState } from '../store-interfaces';
import CrudActionContainer from './CrudActionContainer';

class UserGeodataCRUDActions extends CrudActionContainer {
  retrieveData: string;

  constructor() {
    super('USER_GEODATA');
    this.retrieveData = this.makeActionKey('RETRIEVED_DATA');
  }

  getData() {
    return async (dispatch: Dispatch<StoreState>) => {
      try {
        const response = await UserGeodataController.getData();
        const payload = await response.json();
        dispatch({
          type: this.retrieveData,
          payload,
        });
        return payload;
      } catch (e) {
        return { country_code: undefined };
      }
    };
  }
}

const userGeodataCRUDActions = new UserGeodataCRUDActions();

export default userGeodataCRUDActions;
